@if (importExportShowBothType()) {
  <mat-tab-group>
    <mat-tab
      [label]="'igo.integration.importExportTool.importExportData' | translate"
    >
      <igo-import-export
        [contextUri]="(contextState.context$ | async).uri"
        [map]="map"
        [selectFirstProj]="selectFirstProj()"
        [projectionsLimitations]="projectionsLimitations()"
        [store]="workspaceStore"
        [selectedMode]="importExportState.selectedMode$ | async"
        (selectMode)="modeChanged($any($event))"
        [exportOptions$]="importExportState.exportOptions$"
        (exportOptionsChange)="exportOptionsChange($event)"
      />
    </mat-tab>
    <mat-tab
      [label]="
        'igo.integration.importExportTool.importExportContext' | translate
      "
    >
      <igo-context-import-export [map]="map" />
    </mat-tab>
  </mat-tab-group>
}

@if (!importExportShowBothType() && importExportType() === 'layer') {
  <igo-import-export
    [contextUri]="(contextState.context$ | async).uri"
    [map]="map"
    [store]="workspaceStore"
    [selectedMode]="importExportState.selectedMode$ | async"
    (selectMode)="modeChanged($any($event))"
    [exportOptions$]="importExportState.exportOptions$"
    (exportOptionsChange)="exportOptionsChange($event)"
  />
}

@if (!importExportShowBothType() && importExportType() === 'context') {
  <igo-context-import-export [map]="map" />
}
